import React, { useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField, ListItemIcon, Container } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const UpdateVariant = (props) => {
    const { varintSubmit, variant, setVariant } = props
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();

    // console.log("variant", variant)

    useEffect(() => {
        if (variant) {
            // console.log("variant", variant)
            setValue('id', variant?.id);
            setValue('name', variant?.name);
            setValue('unit', variant?.unit);
            setValue('mrp', variant?.mrp);
            setValue('cost', variant?.cost);
            setValue('stock', variant?.stock);
        }
    }, [variant])



    return (
        <Dialog
            open={variant != null}
            onClose={() => { setVariant(null) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
                Edite Varients
            </DialogTitle>
            <form id="variantEdit-form" onSubmit={handleSubmit(varintSubmit)}>
                <DialogContent>
                    <Grid container spacing={1} mt={5} >
                        <Grid item xs={12} sm={6} md={6} mb={5}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <TextField
                                    fullWidth
                                    id="input-with-sx"
                                    label="Varint"
                                    variant="standard"
                                    {...register("name", { required: 'Enter Food name' })}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <select {...register("unit", { required: 'Select a unit' })}>
                                                    <option value={'kg'}>Kg</option>
                                                    <option value={'ml'}>ml</option>
                                                    <option value={'l'}>l</option>
                                                    <option value={'g'}>g</option>
                                                    <option value={'mg'}>mg</option>
                                                    <option value={'mm'}>mm</option>
                                                    <option value={'cm'}>cm</option>
                                                    <option value={'unit'}>unit</option>
                                                </select>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb={5}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <TextField fullWidth id="input-with-sx" label="MRP" variant="standard" {...register("mrp", { required: 'Enter Food Description' })} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb={5}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <TextField fullWidth id="input-with-sx" label="Selling price" variant="standard" {...register("cost", { required: 'Enter Food name' })} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} mb={5}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                <TextField fullWidth id="input-with-sx" label="Stock Quantity" variant="standard" {...register("stock", { required: 'Enter Food Description' })} />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button type="submit" form="variantEdit-form" autoFocus>
                        Update
                    </Button>
                    <Button onClick={() => { setVariant(null) }}>Cancle</Button>
                </DialogActions>
            </form>
        </Dialog>)
}

export default UpdateVariant
















